import { FirstStepItem } from "./firstStepsToItems";

interface OnboardingPermissions {
	linkedinAllowed: boolean;
	isSequencerActive: boolean;
}

/**
 * Hides connection onboarding steps the user cannot act on:
 * - the "connect senders" row requires a sender licence (`linkedinAllowed`) —
 *   a user without one can connect neither a LinkedIn profile nor an email,
 * - the LinkedIn step requires the `linkedinAllowed` permission, and
 * - the email step additionally requires the SEQUENCER feature,
 * mirroring the gating on the Account page and the setup-guide tour.
 */
export const filterOnboardingItems = (
	items: FirstStepItem[],
	{ linkedinAllowed, isSequencerActive }: OnboardingPermissions
): FirstStepItem[] =>
	items.filter((item) => {
		if (item.key === "connectSenders" && !item.connect) {
			return linkedinAllowed;
		}

		if (item.connect === "linkedin") {
			return linkedinAllowed;
		}

		if (item.connect === "email") {
			return linkedinAllowed && isSequencerActive;
		}

		return true;
	});
